import OrderedListToolbarView from "./OrderedListToolbarView.vue";
import {ListItem as ListItemExtension} from "@tiptap/extension-list-item";
import {OrderedList as OrderedListExtension} from "@tiptap/extension-ordered-list";

export default class OrderedList {

    constructor() {
        this.toolbarView = OrderedListToolbarView;
    }

    static create() {
        return new OrderedList();
    }

    getExtensions() {
        return [ListItemExtension, OrderedListExtension];
    }
}